// hooks/useEditUserForm.js
import { useState } from 'react';
import { toast } from 'react-toastify';
import { removeMask } from './helpers';
import { EditUserPartner } from 'js/library/utils/API/SearchUser/apiEditUserPartner';

export default function useEditUserForm({ clubForms, userData, handleClose }) {
  const [partnerData, setPartnerData] = useState({
    contactList: [],
    documentList: [],
    addressList: [],
    optInList: [],
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const uid = userData?.uId?.value;
      const formFields = clubForms?.formFields || [];

      const contactList = [];
      const documentList = [];
      const addressList = [];
      const optInList = [];
      const partnerPayload = {
        partnerId: clubForms.partnerId,
        partnerName: clubForms.clubeId,
      };

      for (const field of formFields) {
        const { fieldName, label, required, inputMask, type, inputType, fieldType } = field;
        const value = partnerData[fieldName];

        if (type === 'addressList') {
          console.log({
            zipCode: partnerData.zipCode || '',
            streetAve: partnerData.streetAve || '',
            streetNumber: partnerData.streetNumber || '',
            neighborhood: partnerData.neighborhood || '',
            city: partnerData.city || '',
            state: partnerData.state || '',
            extra: partnerData.complement || '',
          });

          const addr = {
            zipCode: partnerData.zipCode || '',
            streetAve: partnerData.streetAve || '',
            streetNumber: partnerData.streetNumber || '',
            neighborhood: partnerData.neighborhood || '',
            city: partnerData.city || '',
            state: partnerData.state || '',
            extra: partnerData.complement || '',
          };
          const isFilled =
            addr?.zipCode ||
            addr?.streetAve ||
            addr?.streetNumber ||
            addr?.neighborhood ||
            addr?.city ||
            addr?.state;

          if (required) {
            if (
              !addr?.zipCode ||
              !addr?.streetAve ||
              !addr?.streetNumber ||
              !addr?.neighborhood ||
              !addr?.city ||
              !addr?.state
            ) {
              toast.error(`Todos os campos de endereço são obrigatórios.`);
              setLoading(false);
              return;
            }
          } else if (
            isFilled &&
            (!addr?.zipCode ||
              !addr?.streetAve ||
              !addr?.streetNumber ||
              !addr?.neighborhood ||
              !addr?.city ||
              !addr?.state)
          ) {
            toast.error(`Preencha todos os campos de endereço ou deixe todos vazios.`);
            setLoading(false);
            return;
          }

          if (addr && addr.zipCode) {
            addressList.push({
              ...addr,
              country: 'Brasil',
              type: 'principal',
              googleAddr: '',
              latitude: 0,
              longitude: 0,
            });
          }
          continue;
        }

        if (
          (required && (!value || value.toString().trim() === '')) ||
          ((inputType === 'date' || fieldType === 'date') &&
            value &&
            !/^\d{4}-\d{2}-\d{2}$/.test(value))
        ) {
          toast.error(`O campo "${label}" é obrigatório ou está com o formato de data inválido.`);
          setLoading(false);
          return;
        }

        if (inputMask && value) {
          const expectedLength = inputMask.replace(/[^#9]/g, '').length;
          const actualLength = removeMask(value).length;
          if (actualLength < expectedLength) {
            toast.error(`O campo "${label}" está incompleto.`);
            setLoading(false);
            return;
          }
        }

        switch (type) {
          case 'addressList':
            if (value && Array.isArray(value) && value.length > 0) {
              addressList.push({
                ...value[0],
                country: 'Brasil',
                type: 'principal',
                googleAddr: '',
                latitude: 0,
                longitude: 0,
              });
            }
            break;

          case 'contactList':
            if (value) {
              contactList.push({
                type: fieldName,
                value,
              });
            }
            break;

          case 'documentList':
            if (value) {
              documentList.push({
                type: fieldName,
                value: removeMask(value),
              });
            }
            break;

          case 'optInList':
            if (typeof value === 'object') {
              optInList.push(value);
            } else {
              optInList.push({
                optInId: fieldName,
                accept: !!value,
                version: 1,
                type: label,
                dateAcceptance: new Date().getTime(),
              });
            }
            break;

          case 'root':
          case 'others':
            if (fieldType === 'date' && value) {
              partnerPayload[fieldName] = new Date(value).getTime();
            } else {
              partnerPayload[fieldName] = value;
            }
            break;

          default:
            break;
        }
      }

      partnerPayload.contactList = contactList;
      partnerPayload.documentList = documentList;
      partnerPayload.addressList = addressList;
      partnerPayload.optInList = optInList;

      console.log('Payload to Edit User:', partnerPayload);

      const response = await EditUserPartner(uid, partnerPayload);
      console.log('Response from Edit User API:', response);

      if (response) {
        toast.success('Usuário atualizado com sucesso.', {
          autoClose: 2000,
          onOpen: () => {
            handleClose();
          },
        });
      } else {
        toast.error('Erro ao atualizar usuário.');
      }
    } catch (error) {
      console.error(error);
      toast.error('Erro interno ao salvar.');
    } finally {
      setLoading(false);
    }
  };

  return {
    partnerData,
    setPartnerData,
    handleSubmit,
    loading,
  };
}
